// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__pDqAi","itemTitle":"ClientEmergencyInfo_itemTitle__XYhGt","itemText":"ClientEmergencyInfo_itemText__3gavV"};